import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { ScrollBar } from "../ScrollBar";
import styles from "./DrawerBody.style";

const DrawerBodyStyled = styled.section((props) => ({ ...styles(props) }));

const DrawerBody = ({
    children,
    disableTopSpacing,
    disableBottomSpacing,
    autoHideScrollbar,
    className,
    ...rest
}) => {
    if (!children) {
        return null;
    }

    return (
        <DrawerBodyStyled
            className={className}
            disableTopSpacing={disableTopSpacing}
            disableBottomSpacing={disableBottomSpacing}
            {...rest}
        >
            <ScrollBar
                maximalThumbYSize={370}
                hasTopShadow={!disableTopSpacing}
                hasBottomShadow={!disableBottomSpacing}
                autoHide={autoHideScrollbar}
            >
                <div className="drawerBody_inner">{children}</div>
            </ScrollBar>
        </DrawerBodyStyled>
    );
};

DrawerBody.propTypes = {
    className: PropTypes.string,
    disableTopSpacing: PropTypes.bool,
    disableBottomSpacing: PropTypes.bool,
    autoHideScrollbar: PropTypes.bool,
};

DrawerBody.defaultProps = {
    className: undefined,
    disableTopSpacing: false,
    disableBottomSpacing: false,
    autoHideScrollbar: false,
};

export default DrawerBody;
